import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { LOGGED_IN_SESSION_KEY } from "../constants";
import { CLUSTER_REGISTRATION_FLOWS } from "../redux/auth";

export const PAGES = {
  workspace: {
    index: "/workspace",
    buildings: "buildings",
    assistance: "assistance",
    tasks: "tasks",
    reports: "reports",
    settings: {
      index: "/settings",
      profile: "profile",
      companySettings: "company-settings",
      portfolioProfile: "portfolio-profile",
      portfolioRegistration: "portfolio-registration",
      usersPermission: "users-and-permissions",
      alertsNotifications: "alerts-and-notifications",
      praasIntegrations: "praas-integrations",
      support: "support",
    },
  },
  login: "/login",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password",
  changePassword: "/change-password",
  emailSuccess: "/email-success",
  privacyPolicy: "/privacy",
  home: "/",
  gettingStarted: {
    index: "/getting-started",
    setup: "setup",
    success: "success",
  },
  dashboard: {
    index: "/dashboard",
    unrealized: "unrealized",
    carbonImpact: "carbon-impact",
    powerAssets: "power-assets",
    powerRevenues: "power-revenues",
    noi: "noi",
  },
  buildings: {
    index: "/buildings",
    complexes: "complexes",
  },
  demo: {
    solar: "solar",
    portfolioRegistration: "portfolio",
    default: "default",
    hotels: "hotels",
  },
  registration: {
    index: "/registration",
    portfolio: "portfolio",
  },
  ssoLogoutCallback: "/logout-callback",
};

export const PrivatePage = ({ component }) => {
  const { user, clusters } = useSelector((state) => state.auth);
  const loggedIn = localStorage.getItem(LOGGED_IN_SESSION_KEY);
  const Component = component;

  if (loggedIn) {
    // Registration for preliminary
    if (
      clusters?.[0]?.preliminary_stage &&
      !location.pathname?.includes(PAGES.registration.index)
    ) {
      return <Navigate to={PAGES.registration.index} />;
    }

    const isDemoPath = CLUSTER_REGISTRATION_FLOWS.some((c) =>
      location.pathname?.includes(c?.toLocaleLowerCase())
    );
    if (user.cluster_registration_flow && !isDemoPath) {
      return <Navigate to={user.cluster_registration_flow} />;
    } else if (!user.cluster_registration_flow && isDemoPath) {
      return <Navigate to={PAGES.home} />;
    }
    return <Component />;
  }
  return (
    <Navigate to={PAGES.login} state={{ redirect: `${location.pathname}${location.search}` }} />
  );
};
